var _defs, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGroww = function SvgGroww(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 275.65 276.4"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".groww_svg__cls-1{fill:#5367fc}.groww_svg__cls-2{fill:#00d9a4;isolation:isolate}"))), /*#__PURE__*/React.createElement("g", {
    id: "groww_svg__Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "groww_svg__Layer_1-2",
    "data-name": "Layer 1"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 138.2v.37a138 138 0 0 0 5.27 37.88l.19-.12A138 138 0 0 1 0 138.2",
    className: "groww_svg__cls-1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M275.64 138.2q0 6.3-.59 12.46l.07-.07c.34-4 .53-8 .53-12 0-.14-.01-.27-.01-.39",
    className: "groww_svg__cls-2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M137.82 0A137.83 137.83 0 0 0 0 137.82v.38a138 138 0 0 0 5.46 38.13l72.45-46.49 83.25 31.24L256.8 69l.28-.27A137.76 137.76 0 0 0 137.82 0",
    className: "groww_svg__cls-1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m257.08 68.71-.28.27-95.64 92.1-83.25-31.24-72.45 46.49-.19.12A137 137 0 0 0 15 201.07l.29-.18 69.3-44.48 83.25 31.24 99.66-96 .2-.19a137 137 0 0 0-10.62-22.75",
    style: {
      fill: "#00ffc3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m267.66 91.49-.2.19-99.66 96-83.25-31.27-69.3 44.48-.29.18a138 138 0 0 0 15.16 23.49l.39-.26 54-34.68 83.25 31.25 106.42-102.44.09-.09a137 137 0 0 0-6.61-26.85",
    style: {
      fill: "#00ebb2"
    }
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m274.27 118.34-.09.09L167.8 220.87l-83.25-31.25-54 34.68-.39.26a138.7 138.7 0 0 0 20 20.33l.52-.34 33.84-21.75 83.21 31.2 107.32-103.34q.57-6.15.59-12.46v-.38a139 139 0 0 0-1.37-19.48",
    className: "groww_svg__cls-2"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M275.05 150.66 167.73 254l-83.21-31.2-33.89 21.75-.52.34a137.83 137.83 0 0 0 225-94.3Z",
    style: {
      isolation: "isolate",
      fill: "#01c897"
    }
  }))));
};
export { SvgGroww as ReactComponent };
export default __webpack_public_path__ + "b000ebc4a604051a8b819d895f478b9f.svg";